<mat-card
    appearance="outlined"
    class="flat mt-10"
    style="margin-bottom: 10px"
>
    <div class="row" >
        <div class="col-xs-6">
            <div
                [id]="identifierService.labelId('viewDirectCallMessaging', 'directMsgng')"
                class="merlin-header"
                style="margin-bottom: 10px"
                [innerHtml]="labels['label.gb.direct_msgng']"
                data-tx-key="label.gb.direct_msgng"
            >
                <!-- {{ 'label.gb.direct_msgng' | translate }} -->
            </div>
            <p
                [id]="identifierService.labelId('viewDirectCallMessaging', 'getPermission')"
                [innerHtml]="labels['label.gb.get_permission']"
                data-tx-key="label.gb.get_permission"
            ></p>

            <div class="check-styl">
                <!-- msgReminderFlg -->
                <mat-checkbox
                    [id]="identifierService.checkboxId('viewDirectCallMessaging', 'msgReminderFlg')"
                    color="primary"
                    [disabled]="true"
                    [(ngModel)]="patRes.messaging.msgReminderFlg"
                >
                    <span
                        [id]="identifierService.labelId('viewDirectCallMessaging', 'autoFollowupReminders')"
                        [innerHtml]="labels['label.gb.auto_followup_reminders']"
                        data-tx-key="label.gb.auto_followup_reminders"
                    ></span
                ></mat-checkbox>
            </div>
            <div class="check-styl">
                <!-- msgOverdueFlg -->
                <mat-checkbox
                    [id]="identifierService.checkboxId('viewDirectCallMessaging', 'msgOverdueFlg')"
                    color="primary"
                    [disabled]="true"
                    [(ngModel)]="patRes.messaging.msgOverdueFlg"
                >
                    <span
                        [id]="identifierService.labelId('viewDirectCallMessaging', 'autoOverdueMsg')"
                        [innerHtml]="labels['label.gb.auto_overdue_msg']"
                        data-tx-key="label.gb.auto_overdue_msg"
                    ></span
                ></mat-checkbox>
            </div>
            <br />
            <ng-container *ngIf="displayViewUI()">
                <div class="row">
                    <div class="col-xs-12"></div>
                </div>
                <div class="row">
                    <div class="col-xs-4">
                        <div
                            [id]="identifierService.labelId('viewDirectCallMessaging', 'notifyPatient')"
                            class="labelText"
                            data-tx-key="label.gb.notify_patient"
                        >
                            {{ labels['label.gb.notify_patient'] }}
                            {{ labels['label.gb.between'] }}
                        </div>
                        <div
                            [id]="identifierService.labelId('viewDirectCallMessaging', 'startTime')"
                            class="infoText"
                            style="margin-bottom: 10px"
                            data-tx-key="patRes?.messaging?.msgLabelStartAmpm"
                        >
                            {{ patRes?.messaging?.msgStartTime }}
                            {{
                                 labels[patRes?.messaging?.msgLabelStartAmpm]
                            }}
                        </div>
                    </div>
                    <div class="col-xs-3">
                        <div
                            [id]="identifierService.labelId('viewDirectCallMessaging', 'andText')"
                            class="labelText"
                            data-tx-key="label.gb.and"
                        >
                            {{ labels['label.gb.and'] }}
                        </div>
                        <div
                            [id]="identifierService.labelId('viewDirectCallMessaging', 'endTime')"
                            class="infoText"
                            style="margin-bottom: 10px"
                            data-tx-key="patRes?.messaging?.msgLabelEndAmpm "
                        >
                            {{ patRes?.messaging?.msgEndTime }}
                            {{  labels[patRes?.messaging?.msgLabelEndAmpm] }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <div
                            [id]="identifierService.labelId('viewDirectCallMessaging', 'drctcallMthd')"
                            class="labelText"
                            [innerHtml]="labels['label.gb.drctcall_mthd']"
                            data-tx-key="label.gb.drctcall_mthd"
                        ></div>
                        <div
                            [id]="identifierService.labelId('viewDirectCallMessaging', 'callMethodValue')"
                            class="infoText"
                            style="margin-bottom: 10px"
                        >
                            {{ getCallMethod() }}
                        </div>
                        <div
                            [id]="identifierService.labelId('viewDirectCallMessaging', 'priMobStdRatesApply')"
                            *ngIf="isPrimaryMobile"
                            data-tx-key="label.gb.std_rates_apply"
                            [innerHTML]="labels['label.gb.std_rates_apply'] | safe: 'html'"
                        >
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="isOtherPhone">
                    <div class="col-xs-3">
                        <div
                            [id]="identifierService.labelId('viewDirectCallMessaging', 'otherPhone')"
                            class="labelText"
                            [innerHtml]="labels['label.gb.other_phone']"
                            data-tx-key="label.gb.other_phone"
                        ></div>
                        <div
                            [id]="identifierService.labelId('viewDirectCallMessaging', 'otherPhoneValue')"
                            class="infoText"
                            style="margin-bottom: 10px"
                        >
                            {{ patRes.patient.patientCallSms }}
                        </div>
                    </div>
                    <div class="col-xs-6 sms-icon">
                        <img
                            src="assets/images/question.png"
                            [mdePopoverTriggerFor]="dataRatesPopover"
                        />
                        <mde-popover
                            #dataRatesPopover="mdePopover"
                            [mdePopoverOverlapTrigger]="false"
                            mdePopoverPositionX="after"
                            mdePopoverPositionY="above"
                            mdePopoverArrowOffsetX="15"
                            [id]="
                                identifierService.dropdownId(
                                    'direct-call-messaging',
                                    'msgInfo'
                                )
                            "
                        >
                            <mat-card appearance="outlined" style="max-width: 300px">
                                <mat-card-content>
                                    <div
                                        [id]="identifierService.labelId('viewDirectCallMessaging', 'textMsgInfo')"
                                        [innerHTML]="labels['label.gb.text_msg_info'] | safe: 'html'"
                                    ></div>
                                </mat-card-content>
                            </mat-card>
                        </mde-popover>
                    </div>
                    <br>
                    <div
                        [id]="identifierService.labelId('viewDirectCallMessaging', 'stdRatesApply')"
                        class="col-xs-12"
                        data-tx-key="label.gb.std_rates_apply"
                        [innerHTML]="labels['label.gb.std_rates_apply'] | safe: 'html'"
                    >
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="col-xs-6">
            <div>
                <h3
                    [id]="identifierService.labelId('viewDirectCallMessaging', 'medTeamHeader')"
                    class="merlin-header"
                    data-tx-key="label.rpt.medical_team"
                >
                    {{ labels['label.rpt.medical_team'] }}
                </h3>
            </div>
            <p
                [id]="identifierService.labelId('viewDirectCallMessaging', 'medTeamAfterHours')"
                data-tx-key="label.gb.place_med_team_after_hours_notif_order_blue"
                [innerHTML]="labels['label.gb.place_med_team_after_hours_notif_order_blue'] | safe: 'html'"
            >
            </p>
            <ng-container *ngIf="displayViewUI()">
                <div
                    [id]="identifierService.labelId('viewDirectCallMessaging', 'physName_' + phys?.id)"
                    *ngFor="let phys of patRes.medTeam.assigned"
                    [ngClass]="{
                        viewImplantingItem: isViewImplanting(phys.id)
                    }"
                >
                    {{ getPhys(phys.id) }}
                </div>
            </ng-container>
        </div>
    </div>
</mat-card>
